<template>
    <div class="menu-container" >
        <ul id="menu" class="menu left-menu">
            <template v-for="item in menu">
                <li :key="`menu-item-${item.id}`"
                    class="menu-item"
                    :class="{ 'active': item.isActive }">
                    <a v-if="item.forceRegularLink || item.external || isIE10"
                       :href="item.url"
                       class="menu-link"
                       :target="item.forceRegularLink ? '':'_blank'">
                        {{ item.title }}
                    </a>
                    <router-link v-else
                                 class="menu-link"
                                 :to="item.url">
                        {{ item.title }}
                    </router-link>
                </li>
            </template>
        </ul>
        <ul class="menu right-menu">
            <li v-if="residentLink.display" class="menu-item">
                <a :href="residentLink.url" class="menu-link">
                    {{ residentLink.text }}
                </a>
            </li>
            <li v-if="phoneLink.display" class="menu-item">
                <a :href="`tel:${phoneNumber}`" class="menu-link phone">
                    <span class="phone-prepend-text">{{ phoneLink.text }}</span>
                    {{ phoneNumber }}
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    import MenuMixin from './mixin.menu'

    export default {
        name: "HeaderMenu",
        mixins: [ MenuMixin ],
        data() {
            return {
                residentLink: wp.settings.headerOptions.resident_link,
                phoneLink: wp.settings.headerOptions.phone_number_link,
                phoneNumber: wp.settings.phoneNumber
            }
        }
    }
</script>

<style lang="scss" scoped>

    .menu-container {
        -ms-grid-column: 2;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .menu {
        margin: 0;
        padding: 0;
        list-style: none;
        display: inline-flex;
        align-items: center;

        &.left-menu {
            padding-left: 20px;
        }

        &.right-menu {
            padding-right: 20px;
        }
    }

    .menu-item {
        height: min-content;

        &.active {
            .menu-link {
                color: $theme-orange;
            }
        }
    }

    .menu-link {
        color: $white;
        font-family: inherit;
        font-size: 12px;
        text-decoration: none;
        text-transform: uppercase;
        padding: 10px;

        &:hover {
            cursor: pointer;
            color: $theme-orange;
        }


    }

    .phone {
        display: flex;
    }

    .phone-prepend-text {
        display: none;
        @media (min-width: 1250px) {
            display: block;
            margin-right: 5px;
        }
    }



</style>